import { render, staticRenderFns } from "./OfficialAccount.vue?vue&type=template&id=0aa8fc24&scoped=true&"
import script from "./OfficialAccount.vue?vue&type=script&lang=js&"
export * from "./OfficialAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa8fc24",
  null
  
)

export default component.exports